export default {"src":"/_next/static/media/application-servers.152cf363.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};